// extracted by mini-css-extract-plugin
module.exports = {"container":"_4997cb3","portfolio":"_1e53b5c","favorites":"fdec244","projects":"_73a1060","header":"_72e27b9","subheader":"_28169b2","box":"ff3e3a6","button":"_4d25dad"};